









import { getConfig } from '@superbet-group/web.lib.config';
import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import { defineComponent } from '@vue/composition-api';

import SportCallerBase from '../SportCallerBase.vue';

export default defineComponent({
    setup() {
        const url = getConfig().fantasticDuels?.url;
        const { router } = useVueRouter();

        function handleRedirect(data: { url: string }) {
            const url = new URL(data.url);
            const path = `${url.pathname}${url.search}`;
            router.value.push({ path: path });
        }

        return {
            url,
            handleRedirect,
        };
    },
    components: {
        SportCallerBase,
    },
});
